const tokenKey = 'codecannon.emailDownloadToken'

export function captureEmailDownloadToken(): void {
	if (!window.location.pathname.endsWith('/downloads')) return
	if (!window.location.hash) return
	storeEmailDownloadToken(window.location.hash)
	window.history.replaceState(
		window.history.state,
		'',
		window.location.pathname + window.location.search,
	)
}

export function storeEmailDownloadToken(hash: string): void {
	const token = hash.slice(1)
	if (/^[A-Za-z0-9]{64}$/.test(token)) {
		sessionStorage.setItem(tokenKey, token)
	} else {
		clearEmailDownloadToken()
	}
}

export function emailDownloadToken(): string | null {
	return sessionStorage.getItem(tokenKey)
}

export function clearEmailDownloadToken(): void {
	sessionStorage.removeItem(tokenKey)
}

// The auth guard clears the token once the recipient leaves the download and sign-in pages, so a stored token
// means signing in should return to the download.
export function emailDownloadReturn(): string | null {
	return emailDownloadToken() ? '/downloads' : null
}
